import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputText from '../Common/InputText';
import Toggle from '../Common/Toggle/Toggle';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import TextArea from '../Common/TextArea';
import RadioGroup from '../Common/RadioGroup/RadioGroup';
import { USER_LOCATION_ACCESS_OPTIONS } from '../../constants/constants';
import UserLocationAccessForm from '../Common/UserLocationAccessForm/UserLocationAccessForm';


export default class UserProfileForm extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onFormChange = (e) => {
        let value = e.target.value;
        if (e.target.name === 'userName') {
            value = value.replace(/[^a-zA-Z0-9._+-@]/g, ''); // Allows letters, numbers, and specific special characters
        }

        this.props.onFormChange(e.target.name, value);
    }

    onSingleSelectChange = (id, name) => {
        this.props.onFormChange(name, id);
    }

    onMultiSelectChange = (csv, name) => {
        let ar = (csv.indexOf(",") == -1) ? [csv] : csv.split(",");
        if (csv === '')
            ar = [];
        this.props.onFormChange(name, ar);
    }

    onSSOToggleChange = (name, value) => {
        this.props.onSSOToggleChange(value);
    }

    onUserLocationAccessChange = (value) => {
        this.props.onFormChange('selectedUserLocationAccess', value);
    }

    render() {
        return (
            <div>
                {this.props.user.subscriptionNames.length > 0
                    ?
                    <div name="subscriptionNamesMessage" className="alert alert-info">This user is a member of multiple subscriptions: {this.props.user.subscriptionNames.toString()}</div>
                    : ""
                }
                <div className="invite-user-form">
                    <form noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputText name="firstName" label="First Name" placeholder="First Name" type="text" value={this.props.user.firstName} onChange={this.onFormChange} isRequired={true} errorMessage="First Name is required" />
                                <InputText name="lastName" label="Last Name" placeholder="Last Name" type="text" value={this.props.user.lastName} onChange={this.onFormChange} isRequired={true} errorMessage="Last Name is required" />
                                <InputText name="email" label="Email" placeholder="Email" type="text" value={this.props.user.email} onChange={this.onFormChange} isRequired={true} errorMessage="Email is required" />
                                <InputText name="userName" label="UserName" placeholder="UserName" type="text" value={this.props.user.userName} onChange={this.onFormChange} isRequired={!this.props.user.isSSOUser} isDisabled={this.props.user.isSSOUser} errorMessage="UserName is required" />
                                <InputText name="workPhone" label="Work Phone" placeholder="Work Phone" type="text" value={this.props.user.workPhone} onChange={this.onFormChange} />
                                <InputText name="jobTitle" label="Job Title" placeholder="Job Title" type="text" value={this.props.user.jobTitle} onChange={this.onFormChange} />

                                <MultiSelectBox name="countryId" label="Country" idField="id" valueField="name"
                                    options={this.props.countries}
                                    onChange={this.onSingleSelectChange}
                                    selectedValues={this.props.user.countryId.toString()}
                                    isRequired={true}
                                    errorMessage="Country is required"
                                    isMulti={false}
                                />
                            </div>
                            <div className="col-md-6">
                                <MultiSelectBox name="roleId" label="Role" idField="id" valueField="name"
                                    options={this.props.roles}
                                    onChange={this.onSingleSelectChange}
                                    selectedValues={this.props.user.roleId.toString()}
                                    isRequired={true}
                                    errorMessage="Role is required"
                                    isMulti={false}
                                />

                                <MultiSelectBox name="managementCompanyId" label="Management Company" idField="id" valueField="name"
                                    options={this.props.managementCompanies}
                                    onChange={this.onSingleSelectChange}
                                    selectedValues={this.props.user.managementCompanyId.toString()}
                                    isRequired={true}
                                    errorMessage="Management Company is required"
                                    isMulti={false}
                                />

                                <MultiSelectBox name="communityIds" label="Communities" idField="id" valueField="name"
                                    options={this.props.communities}
                                    selectedValues={this.props.user.communityIds.toString()}
                                    onChange={this.onMultiSelectChange}
                                    isRequired={true}
                                    errorMessage="At least one Community must be selected"
                                    isMulti={true}
                                />

                                <MultiSelectBox name="departmentIds" label="Favorite Departments" idField="id" valueField="name"
                                    options={this.props.departments}
                                    selectedValues={this.props.user.departmentIds.toString()}
                                    onChange={this.onMultiSelectChange}
                                    isRequired={false}
                                    isMulti={true}
                                />

                                <TextArea 
                                    name="internalComment" 
                                    label="Internal Comment"
                                    rows={5} 
                                    placeholder="Internal Comment"
                                    value={this.props.user.internalComment}
                                    onChange={this.onFormChange}
                                    maxLength={1000} />
                                <div className="remaining-chars text-end">{this.props.user.internalComment.length}/1000</div>

                                <Toggle name="isActive" text="Active" checked={this.props.user.isActive} onChange={this.onToggleChange} />
                                {
                                    this.props.isSubscriptionProjectEnabled
                                        ?
                                        <Toggle name="excludeAsProjectCoach" text="Exclude as Project Coach" checked={this.props.user.excludeAsProjectCoach} onChange={this.onToggleChange} />
                                        :
                                        null
                                }

                                <Toggle name="allowTaskListExportToExcel" text="Allow Location Task List Export to Excel" checked={this.props.user.allowTaskListExportToExcel} onChange={this.onToggleChange} />
                                <Toggle name="allowLocationTaskDateChanges" text="Allow Location Task Date Changes" checked={this.props.user.allowLocationTaskDateChanges} onChange={this.onToggleChange} />

                                {
                                    this.props.isSubscriptionTaskFinancialsActive
                                        ?
                                        <Toggle name="allowLocationTaskBudgetEntry" text="Allow Location Task Budget Entry" checked={this.props.user.allowLocationTaskBudgetEntry} onChange={this.onToggleChange} />
                                        :
                                        null
                                }

                                {
                                    this.props.isSubscriptionSsoEnabled
                                        ?
                                        <Toggle name="ssoUser" text="SSO User" checked={this.props.user.isSSOUser} onChange={this.onSSOToggleChange} />
                                        :
                                        null
                                }
                                {
                                    this.props.isSubscriptionSsoEnabled && this.props.user.isSSOUser
                                        ?
                                        <InputText name="userName" label="SSO Id" placeholder="SSO Id" type="text" value={this.props.user.userName} onChange={this.onFormChange}
                                            isRequired={this.props.user.isSSOUser}
                                            errorMessage="SSO Id is required for SSO Users"
                                        />
                                        :
                                        null
                                }

                                <div>Grant User Access To All Locations</div>
                                <RadioGroup 
                                    defaultValue={this.props.user.selectedUserLocationAccess}
                                    value={this.props.user.selectedUserLocationAccess}
                                    options={[
                                        {  value: USER_LOCATION_ACCESS_OPTIONS.NO.value, label: USER_LOCATION_ACCESS_OPTIONS.NO.label },
                                        {  value: USER_LOCATION_ACCESS_OPTIONS.YES.value, label: USER_LOCATION_ACCESS_OPTIONS.YES.label },
                                        {  value: USER_LOCATION_ACCESS_OPTIONS.RULES.value, label: USER_LOCATION_ACCESS_OPTIONS.RULES.label },
                                    ]}
                                    onValueChange={this.onUserLocationAccessChange} />

                                {
                                    this.props.user.selectedUserLocationAccess === USER_LOCATION_ACCESS_OPTIONS.RULES.value
                                        ?
                                        <UserLocationAccessForm
                                            subscriptionId={this.props.subscriptionId}
                                            isFormValid={this.props.isUserLocationAccessFormValid}
                                            userLocationRules={this.props.user.userLocationRules}
                                            onFormChange={this.props.onUserLocationAccessFormChange}
                                            actions={this.props.locationActions}
                                        />
                                        :
                                        null
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        );
    }
}

UserProfileForm.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    isSubscriptionProjectEnabled: PropTypes.bool.isRequired,
    isSubscriptionSsoEnabled: PropTypes.bool.isRequired,
    isSubscriptionTaskFinancialsActive: PropTypes.bool.isRequired,
    countries: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,
    managementCompanies: PropTypes.array.isRequired,
    communities: PropTypes.array.isRequired,
    departments: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired,
    onSSOToggleChange: PropTypes.func.isRequired,
    isUserLocationAccessFormValid: PropTypes.bool.isRequired,
    onUserLocationAccessFormChange: PropTypes.func.isRequired,
    locationActions: PropTypes.object.isRequired
}
